import { useFetchPrice, useGetBookingSession } from '@massilia/queries'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'
import { InformationsPage } from '@/routes/informations/-components/informations-page'
import { useBookingPricePreviewStore } from '@/stores/booking-price-preview.store'

export const Route = createFileRoute('/_booking/informations')({
  component: InformationsRoute,
  validateSearch: bookingSessionSearchSchema,
})

export function InformationsRoute() {
  const { session: sessionId } = Route.useSearch()

  const { data: session, isLoading } = useGetBookingSession(sessionId, {
    throwOnError: true,
  })

  // Eagerly fetch Affidium price data on page load (for sidebar luggage/price display).
  // throwOnError: a price failure must surface via the _booking BookingError boundary
  // instead of leaving the sidebar skeleton spinning indefinitely.
  const { isLoading: isPriceLoading } = useFetchPrice(sessionId, { throwOnError: true })

  // L'aperçu posé à la sélection du vol n'a plus lieu d'être une fois le price confirmé
  // persisté sur la session : on le purge pour qu'il ne survive pas à la réservation.
  const clearPricePreview = useBookingPricePreviewStore((state) => state.clearPricePreview)
  const previewSessionId = useBookingPricePreviewStore((state) => state.sessionId)
  useEffect(() => {
    if (session?.priceData && previewSessionId === sessionId) {
      clearPricePreview()
    }
  }, [clearPricePreview, previewSessionId, session?.priceData, sessionId])

  return (
    <InformationsPage
      isLoading={isLoading}
      isPriceLoading={isPriceLoading}
      session={session}
      sessionId={sessionId}
    />
  )
}
